// Import vue
import Vue from 'vue';

// Import filters
import formatBytes from './formatBytes';
import formatDate from './formatDate';
import formatDateTime from './formatDateTime';
import formatSize from './formatSize';
import toCurrency from './toCurrency';
import newlineToBreak from './newlineToBreak';

// Define filters
Vue.filter('formatBytes', formatBytes);
Vue.filter('formatDate', formatDate);
Vue.filter('formatDateTime', formatDateTime);
Vue.filter('formatSize', formatSize);
Vue.filter('toCurrency', toCurrency);
Vue.filter('newlineToBreak', newlineToBreak);